module.exports = __webpack_public_path__ + "img/ssyx_15.daad24f9.jpg";